module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/air_gun/icon_ca8623907d195f8b11d34245e1f7e885.png";